import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['parentCheckbox', 'childCheckbox']

  declare parentCheckboxTarget: HTMLInputElement
  declare childCheckboxTargets: HTMLInputElement[]

  tickCheckboxes (): void {
    if (this.parentCheckboxTarget.checked) {
      this.childCheckboxTargets.forEach((checkbox) => { checkbox.checked = true })
    } else {
      this.childCheckboxTargets.forEach((checkbox) => { checkbox.checked = false })
    }
  }
}
